"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.X25519EncryptedData = void 0;
class X25519EncryptedData {
    constructor(data) {
        this.nonce = data.nonce;
        this.version = data.version;
        this.cipher = data.cipher;
        this.ciphertext = data.ciphertext;
        this.mac = data.mac;
        this.identities = data.identities;
    }
    toJSON() {
        return {
            version: this.version,
            nonce: this.nonce,
            identities: this.identities,
            crypto: {
                ciphertext: this.ciphertext,
                cipher: this.cipher,
                mac: this.mac,
            }
        };
    }
    static fromJSON(data) {
        return new X25519EncryptedData({
            nonce: data.nonce,
            version: data.version,
            ciphertext: data.crypto.ciphertext,
            cipher: data.crypto.cipher,
            mac: data.crypto.mac,
            identities: data.identities,
        });
    }
}
exports.X25519EncryptedData = X25519EncryptedData;
//# sourceMappingURL=x25519EncryptedData.js.map